import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Card, CardBody, Col, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import CustomDataTable from '../../../../Components/CustomTable/CustomTable';
import { Triangle } from 'react-loader-spinner';
import { RestroUsers } from '../../../../services/DatabaseService/RestroUsers';
import { formatDateTime } from '../../../../Components/Common/FormatDate';

const PaymentLogs = () => {
    const { apiKey } = useParams();
    const [loading, setLoading] = useState(false)
    const [userData, setUserData] = useState(null);
    const [paymentLogs, setPaymentLogs] = useState([]);

    const customStyles = {
        headCells: {
            style: {
                fontSize: "0.92rem",
                fontWeight: 610,
                width: "max-content",
            },
        },
        rows: {
            style: {
                fontSize: "0.9rem",
            },
        },
    };

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true);
            try {
                const result = await RestroUsers.getByApiKey(apiKey);
                setUserData(result);
                setPaymentLogs(result?.paymentLogs || []);
            } catch (error) {
                console.error("Error fetching data", error);
            } finally {
                setLoading(false);
            }
        };
        fetchAllData();
    }, [apiKey]);

    const columns = [
        {
            name: "S No",
            selector: (row, index) => index + 1,
            width: "80px",
            sortable: true,
        },
        {
            name: "Amount Received",
            selector: (row) => row.amountRecived,
            sortable: true,
        },
        {
            name: "Payment Type",
            selector: (row) => {
                switch (row.paymentType) {
                    case 1: return "Cheque";
                    case 2: return "Online";
                    case 3: return "Cash";
                    default: return "Unknown";
                }
            },
            sortable: true,
        },
        {
            name: "Payment Date",
            selector: (row) => formatDateTime(row.paymentDate),
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => row.isPaymentSuccessfull,
            cell: (row) => (
                <span className={`badge ${row.isPaymentSuccessfull ? "bg-success" : "bg-danger"}`}>
                    {row.isPaymentSuccessfull ? "Success" : "Failed"}
                </span>
            ),
            sortable: true,
        }
    ];

    return (
        <div className='page-content py-0'>
            <div className='container-fluid px-0'>

                {/* DESKTOP TABLE VIEW */}
                <Card className="d-none d-md-block d-lg-block">
                    <CardBody>
                        <CustomDataTable
                            responsive
                            striped
                            pagination
                            fixedHeader
                            persistTableHead
                            progressPending={loading}
                            customStyles={customStyles}
                            progressComponent={
                                <div className="my-3 d-flex flex-column align-items-center">
                                    <Triangle visible={true} height="80" width="80" color="#5B71B9" />
                                    <h5 className="mt-2">Loading...</h5>
                                </div>
                            }
                            columns={columns}
                            data={paymentLogs || []}
                        />
                    </CardBody>
                </Card>

                {/* MOBILE VIEW CARD LIST */}
                {loading ? (
                    <div className="my-5 d-flex justify-content-center">
                        <h5>Loading...</h5>
                    </div>
                ) : (
                    <>
                        {paymentLogs?.map((item, index) => (
                            <Card key={index} className="mb-3 shadow-sm d-block d-md-none mt-2">
                                <CardBody>
                                    <Row>
                                        <Col xs={10}>
                                            <h6 className="mb-2"><strong>S No:</strong> {index + 1}</h6>

                                            <h6 className="mb-2">
                                                <strong>Amount:</strong> {item.amountRecived}
                                            </h6>

                                            <h6 className="mb-2">
                                                <strong>Payment Type:</strong>{" "}
                                                {item.paymentType === 1 ? "Cheque" :
                                                 item.paymentType === 2 ? "Online" :
                                                 item.paymentType === 3 ? "Cash" : "Unknown"}
                                            </h6>

                                            <h6 className="mb-2">
                                                <strong>Payment Date:</strong>{" "}
                                                {formatDateTime(item.paymentDate)}
                                            </h6>

                                            <h6 className="mb-2"><strong>Status:</strong></h6>
                                            {item.isPaymentSuccessfull ? (
                                                <span className="badge bg-success px-2 py-1">Success</span>
                                            ) : (
                                                <span className="badge bg-danger px-2 py-1">Failed</span>
                                            )}
                                        </Col>

                                        {/* MOBILE DROPDOWN ACTION BUTTON */}
                                        <Col xs={2}>
                                            <Dropdown
                                                isOpen={item.dropdownOpen || false}
                                                toggle={(e) => {
                                                    e.stopPropagation();
                                                    setPaymentLogs((prev) =>
                                                        prev.map((pItem) =>
                                                            pItem.id === item.id
                                                                ? { ...pItem, dropdownOpen: !pItem.dropdownOpen }
                                                                : { ...pItem, dropdownOpen: false }
                                                        )
                                                    );
                                                }}
                                            >
                                                <DropdownToggle
                                                    color="primary"
                                                    outline
                                                    className="btn-sm shadow-sm rounded-circle"
                                                >
                                                    <i className="ri-more-2-fill"></i>
                                                </DropdownToggle>
                                                <DropdownMenu end>
                                                    <DropdownItem>
                                                        <i className="ri-edit-line text-warning me-2"></i> Edit
                                                    </DropdownItem>
                                                    <DropdownItem>
                                                        <i className="ri-delete-bin-5-line text-danger me-2"></i> Delete
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        ))}
                    </>
                )}

            </div>
        </div>
    );
};

export default PaymentLogs;
